export default "__VITE_ASSET__BXdlyDoW__"